import React, { useId } from 'react';

/**
 * Campo — rótulo sempre visível, ajuda opcional e erro explicado.
 * `children` é uma função que recebe as props de ligação (id, aria) e devolve o controle.
 *
 * <Campo rotulo="Número CNJ" ajuda="Formato 0000000-00.0000.0.00.0000">
 *   {(p) => <input {...p} className="sj-campo__entrada sj-num" />}
 * </Campo>
 */
export default function Campo({ rotulo, ajuda, erro, id, children, className = '' }) {
  const gerado = useId();
  const campoId = id || `campo-${gerado}`;
  const ajudaId = `${campoId}-ajuda`;
  const temErro = Boolean(erro);
  const temAjuda = temErro || Boolean(ajuda);

  const controle = children({
    id: campoId,
    'aria-invalid': temErro || undefined,
    'aria-describedby': temAjuda ? ajudaId : undefined,
  });

  return (
    <div className={['sj-campo', temErro ? 'sj-campo--erro' : '', className].filter(Boolean).join(' ')}>
      <label className="sj-campo__rotulo" htmlFor={campoId}>{rotulo}</label>
      {controle}
      {temAjuda && <span id={ajudaId} className="sj-campo__ajuda">{temErro ? erro : ajuda}</span>}
    </div>
  );
}
